module.exports = __webpack_public_path__ + "media/images/email_templates/inside_cureus_thumbnail-a648f8ddf674d91f002cba089727a9c4.png";